import { Grid, styled } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { memo, useMemo } from "react";
import ButtonIndicator, { ButtonIndicatorProps } from "./ButtonIndicator";
import usePropertyHelpTypeLocations from "../../hooks/helps/usePropertyHelpTypeLocations";
import { keysIndicatorsObject } from "../../util/schemas/property-schema/propertySchema";
import translatePropertyLabels from "../../util/helps/translatePropertyLabels";

interface IPropertyHeaderFormProps {}

const PropertyHeaderForm = (props: IPropertyHeaderFormProps) => {
  const { isProject } = usePropertyHelpTypeLocations();

  const tabs: ButtonIndicatorProps[] = useMemo(() => {
    return [
      {
        label: "Ubicación",
        id: 0,
        step: "location",
        show: true,
        fieldNames: keysIndicatorsObject.location,
        disabledRedirect: true,
        fnTranslate: translatePropertyLabels
      },
      {
        label: "Descripción",
        id: 1,
        step: "description",
        show: true,
        fieldNames: keysIndicatorsObject.description,
        disabledRedirect: true,
        fnTranslate: translatePropertyLabels
      },
      {
        label: "Documentación",
        id: 2,
        step: "document",
        show: true,
        fieldNames: keysIndicatorsObject.document,
        disabledRedirect: true,
        fnTranslate: (label: string) => {
          return translatePropertyLabelsFormCaptation(
            translatePropertyLabels(label)
          );
        }
      },
      {
        label: "Multimedia",
        id: 3,
        step: "multimedia",
        show: true,
        fieldNames: keysIndicatorsObject.multimedia,
        disabledRedirect: true,
        fnTranslate: translatePropertyLabels
      },
      {
        label: "Etapas y unidades",
        id: 4,
        step: "buildings",
        show: isProject,
        fieldNames: keysIndicatorsObject.buildings,
        disabledRedirect: false,
        fnTranslate: translatePropertyLabels,
        excludeFields: (e: string) => e == "unitsQuantity"
      }
    ].filter(x => x.show);
  }, []);

  return (
    <Grid container item xs={12} spacing={1} p={1}>
      <Grid item xs={12} mx={1}>
        <MxTypography variant="overline" color="GrayText">
          Completa los formularios
        </MxTypography>
      </Grid>

      <ContentTabs item id="content-tabs">
        {tabs.map(x => (
          <ButtonIndicator {...x} key={x.id} />
        ))}
      </ContentTabs>
    </Grid>
  );
};

export default memo(PropertyHeaderForm);

const ContentTabs = styled(Grid)(({ theme }) => ({
  flexWrap: "nowrap",
  overflow: "hidden",
  overflowY: "auto",
  display: "flex",
  gap: 0.5,
  alignItems: "center",
  whiteSpace: "nowrap",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100vw	",
    overflowX: "auto",
    scrollbarWidth: "none",
    scrollSnapType: "x mandatory",
    scrollBehavior: "smooth",
    "&> *": {
      scrollSnapAlign: "start"
    }
  }
}));

const translatePropertyLabelsFormCaptation = (label: string) => {
  let newLabel = label;
  newLabel = newLabel.replace(/\[(\d+)]./, (_, num) => ` ${Number(num) + 1} `);
  newLabel = newLabel.replace(/\[(\d+)]./, (_, num) => ` ${Number(num) + 1} `);
  newLabel = newLabel.replace(/\[(\d+)]./, (_, num) => ` ${Number(num) + 1} `);
  newLabel = newLabel.replace(
    /\[(\d+)](?:\.|$)/,
    (_, num) => ` #${Number(num) + 1} `
  );

  newLabel = newLabel.replace(/Etapa /, "Captación ");

  return newLabel;
};
